<template>
  <div class="banner-grid-container">
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerGrid.TITLE"
      tag="h2"
      :class="' banner-grid-title text-center '"
    />
    <ebsn-meta
      :target="config"
      path="categoryblocktype_BannerGrid.DESCRIPTION"
      tag="div"
      :class="' banner-grid-description text-center '"
    />

    <v-row class="banner-grid-row">
      <v-col
        v-for="(proposal, index) in config.proposals"
        :key="proposal.id"
        class="banner-grid-col"
        :cols="getColData(index, 'xs')"
        :sm="getColData(index, 'sm')"
        :md="getColData(index, 'md')"
        :lg="getColData(index, 'lg')"
        :xl="getColData(index, 'xl')"
      >
        <component
          :is="getProposalModelName(proposal)"
          :proposal="proposal"
          class="h-100"
        />
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss">
.banner-grid-container {
  .banner-grid-title {
    color: var(--v-primary-lighten1);
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .banner-grid-description {
    margin-bottom: 12px;
  }
}
</style>
<script>
import ProposalImage from "./elements/ProposalImage.vue";
import ProposalCard from "./elements/ProposalCard.vue";
import ProposalCardOverlay from "./elements/ProposalCardOverlay.vue";
import ProposalButton from "./elements/ProposalButton.vue";

import deliveryReactive from "~/mixins/deliveryReactive";
import categoryBlockType from "./categoryBlockType";

import get from "lodash/get";

export default {
  name: "BannerGrid",
  props: {
    config: { type: Object, required: true },
    container: { type: Boolean, default: true }
  },
  components: {
    ProposalImage,
    ProposalCard,
    ProposalCardOverlay,
    ProposalButton
  },
  mixins: [deliveryReactive, categoryBlockType],
  data() {
    return {};
  },
  computed: {
    rows() {
      return get(
        this.config,
        "metaData.categoryblocktype_BannerGrid.JSON_CONFIG.rows",
        [{ xs: "12", sm: "6", md: "4", lg: "4", xl: "4" }]
      );
    }
  },
  methods: {
    getColData(index, fieldPath) {
      if (index < this.rows.length) {
        return get(this.rows[index], fieldPath, 12);
      }
      return get(this.rows[0], fieldPath, 12);
    }
  }
};
</script>
